// client/src/api/ApiFeedback.js
import flex from './FlexFetch'

const endpoint = '/api/1.0/feedback/'

async function create(message, pageUrl = null) {
  const response = await flex.flexFetch(endpoint + 'create', {
    method: 'POST',
    body: JSON.stringify({
      message,
      page_url: pageUrl || window.location.href,
    }),
  })
  const payload = await flex.handleResponse(response)
  return payload?.success === true ? payload.data : payload
}

async function getAll() {
  const response = await flex.flexFetch(endpoint + 'all')
  const payload = await flex.handleResponse(response)
  return payload?.success === true ? payload.data : payload
}

async function deleteFeedback(id) {
  const response = await flex.flexFetch(endpoint + 'delete', {
    method: 'POST',
    body: JSON.stringify({ id }),
  })
  const payload = await flex.handleResponse(response)
  return payload?.success === true ? payload.data : payload
}

const ApiFeedback = { create, getAll, delete: deleteFeedback }
export default ApiFeedback
